module.exports = __webpack_public_path__ + "img/djembefolla_petit.85a96b6c.png";